<template>
  <div>
    <b-row>
      <b-col align-self="end">
        <b-button style="float:right;padding: 8px; margin: 7px;" v-if="$can('create', 'Pr Fert Programacion')"
          :disabled="loadingExp" variant="gradient-primary" size="sm" class="mr-1" @click="exportarDataExcel">
          <font-awesome-icon v-if="loadingExp" icon="fa-solid fa-arrows-rotate" spin />
          <font-awesome-icon v-else icon="fa-solid fa-file-excel" /> Descargar Plantilla
        </b-button>
      </b-col>
    </b-row>
    <b-row>
      <b-col xl="6" lg="12">
        <b-card no-body v-if="mostrarSemAct">
          <b-card-body class="px-1 pb-0 pt-1">
            <b-row>
              <b-col xl="1" lg="1" md="1" class="mb-1" align="center">
                <b-button-group>
                  <b-button variant="gradient-primary" size="sm" @click="mostrarSemAct = false" id="btn_back">
                    <font-awesome-icon icon="fa-solid fa-arrow-left-long" />
                  </b-button>
                  <b-tooltip title="Regresar" target="btn_back" />
                </b-button-group>
              </b-col>
              <b-col xl="11" lg="11" md="1" class="mb-1" align="center">
                <span class="font-weight-bolder font-small-4"
                  style="vertical-align: -webkit-baseline-middle!important;">Detalle de registros</span>
              </b-col>
            </b-row>

          </b-card-body>
          <b-table v-if="$can('read', 'Pr Fert Programacion')" ref="tableDetalleSemanaActual" responsive hover outlined
            sticky-header="58vh" class="position-relative tablaferti" :items="items_sem_act"
            :fields="fields_detalle_SemAct" :busy="loading" show-empty
            empty-text="No se encontraron datos en esta tabla.">
            <template #table-busy>
              <div class="text-center text-dark my-1">
                <b-spinner class="align-middle"></b-spinner> &emsp;
                <strong>Obteniendo datos...</strong>
              </div>
            </template>

            <template #cell(acciones)="data">
              <div class="text-nowrap">
                <feather-icon v-if="$can('update', 'Pr Fert Programacion')" :id="`btn_${data.item.id}_editar`"
                  icon="EditIcon" size="16" @click="validarEditar(data.item, true)" />
                <b-tooltip title="Editar registro" :target="`btn_${data.item.id}_editar`" />
              </div>
            </template>

            <template #cell(estado)="data">
              <b-badge :variant="status[1][parseInt(data.value)]">
                {{ status[0][parseInt(data.value)] }}
              </b-badge>
            </template>

            <template #cell(created)="data">
              <span>
                {{
                  new Date(data.value).toLocaleString('pe-PE', {
                    year: 'numeric',
                    month: '2-digit',
                    day: '2-digit',
                    localeMatcher: 'best fit',
                    hour: '2-digit',
                    minute: '2-digit',
                    hour12: true,
                    timeZone: 'America/Lima'
                  })
                }}
              </span>
            </template>
          </b-table>
        </b-card>

        <b-card no-body v-else>
          <b-card-body class="px-1 pb-0 pt-1">
            <b-row>
              <b-col xl="3" lg="3" md="3" class="mb-1 align-self-center">
                <b-button-group>
                  <b-button variant="gradient-primary" size="sm" @click="traerMaquinaria" id="act_semAct">
                    <font-awesome-icon icon="fa-solid fa-arrows-rotate" :spin="loading" />
                  </b-button>
                  <b-tooltip title="Actualizar Tabla" target="act_semAct" />
                  <b-button v-if="$can('create', 'Pr Fert Programacion')" variant="gradient-primary" size="sm"
                    @click="modal_registro(true)" id="cre_semAct">
                    <font-awesome-icon icon="fa-solid fa-plus" />
                  </b-button>
                  <b-tooltip title="Crear Registro" target="cre_semAct" />

                  <b-button variant="gradient-primary" size="sm" v-if="$can('create', 'Pr Fert Programacion')"
                    @click="mostrarModalImportar(true)" v-b-modal.modal-importar id="imp_semAct">
                    <font-awesome-icon icon="fa-solid fa-file-excel" />
                  </b-button>
                  <b-tooltip title="Importar Registros" target="imp_semAct" />
                </b-button-group>
              </b-col>
              <b-col xl="9" lg="9" md="9" class="mb-1" align="center">
                <span class="font-weight-bolder font-medium-3"
                  style="vertical-align: -webkit-baseline-middle!important;">{{ `Semana actual N°
                  ${this.semana}`
                  }}</span><br>
                <span class="font-weight-bolder font-small-4"
                  style="vertical-align: -webkit-baseline-middle!important;">{{ `Del ${this.inicioSemana} al
                  ${this.finSemana}`
                  }}</span>
              </b-col>
            </b-row>
          </b-card-body>

          <b-table v-if="$can('read', 'Pr Fert Programacion')" ref="tableSemanaActual" responsive hover outlined
            sticky-header="58vh" class="position-relative tablaferti" :items="items" :fields="fields" :filter="filter"
            :filter-included-fields="filterOn" :sort-by.sync="sortBy" :sort-desc.sync="sortDesc"
            :sort-direction="sortDirection" @filtered="cPaginacion" :busy="loading" show-empty
            empty-text="No se encontraron datos en esta tabla."
            emptyFilteredText="No se encontraron datos con los parámetros ingresados.">
            <template #table-busy>
              <div class="text-center text-dark my-1">
                <b-spinner class="align-middle"></b-spinner> &emsp;
                <strong>Obteniendo datos...</strong>
              </div>
            </template>

            <template #cell(acciones)="data">
              <div class="text-nowrap">

                <feather-icon v-if="$can('read', 'Pr Fert Programacion')" :id="`btn_${data.item.id}_detalle`"
                  icon="EyeIcon" size="16" class="mr-1 text-primary" @click="verDetalle(data.item)" />
                <b-tooltip title="Ver detalle" :target="`btn_${data.item.id}_detalle`" />

                <feather-icon v-if="$can('authorize', 'Pr Fert Programacion')" :id="`btn_${data.item.id}_autorizar`"
                  icon="UserCheckIcon" size="16" @click="autorizar(data.item)" />
                <b-tooltip title="Autorizar" :target="`btn_${data.item.id}_autorizar`" />

              </div>
            </template>

            <template #cell(estado)="data">
              <b-badge :variant="status[1][parseInt(data.value)]">
                {{ status[0][parseInt(data.value)] }}
              </b-badge>
            </template>

            <template #cell(created)="data">
              <span>
                {{
                  new Date(data.value).toLocaleString('pe-PE', {
                    year: 'numeric',
                    month: '2-digit',
                    day: '2-digit',
                    localeMatcher: 'best fit',
                    hour: '2-digit',
                    minute: '2-digit',
                    hour12: true,
                    timeZone: 'America/Lima'
                  })
                }}
              </span>
            </template>
          </b-table>
        </b-card>
      </b-col>

      <b-col xl="6" lg="12">
        <b-card no-body v-if="mostrarSemSgte">
          <b-card-body class="px-1 pb-0 pt-1">
            <b-row>
              <b-col xl="1" lg="1" md="1" class="mb-1" align="center">
                <b-button-group>
                  <b-button variant="gradient-primary" size="sm" @click="mostrarSemSgte = false" id="btn_backSgte">
                    <font-awesome-icon icon="fa-solid fa-arrow-left-long" />
                  </b-button>
                  <b-tooltip title="Regresar" target="btn_backSgte" />
                </b-button-group>
              </b-col>
              <b-col xl="11" lg="11" md="1" class="mb-1" align="center">
                <span class="font-weight-bolder font-small-4"
                  style="vertical-align: -webkit-baseline-middle!important;">Detalle de registros</span>
              </b-col>
            </b-row>
          </b-card-body>

          <b-table v-if="$can('read', 'Pr Fert Programacion')" ref="tableDetalleSemanaSgte" responsive hover outlined
            sticky-header="58vh" class="position-relative tablaferti" :items="items_sem_sgte"
            :fields="fields_detalle_SemAct" :busy="loading" show-empty
            empty-text="No se encontraron datos en esta tabla.">
            <template #table-busy>
              <div class="text-center text-dark my-1">
                <b-spinner class="align-middle"></b-spinner> &emsp;
                <strong>Obteniendo datos...</strong>
              </div>
            </template>

            <template #cell(acciones)="data">
              <div class="text-nowrap">
                <feather-icon v-if="$can('update', 'Pr Fert Programacion')" :id="`btn_${data.item.id}_editar`"
                  icon="EditIcon" size="16" @click="validarEditar(data.item, false)" />
                <b-tooltip title="Editar registro" :target="`btn_${data.item.id}_editar`" />
              </div>
            </template>

            <template #cell(estado)="data">
              <b-badge :variant="status[1][parseInt(data.value)]">
                {{ status[0][parseInt(data.value)] }}
              </b-badge>
            </template>

            <template #cell(created)="data">
              <span>
                {{
                  new Date(data.value).toLocaleString('pe-PE', {
                    year: 'numeric',
                    month: '2-digit',
                    day: '2-digit',
                    localeMatcher: 'best fit',
                    hour: '2-digit',
                    minute: '2-digit',
                    hour12: true,
                    timeZone: 'America/Lima'
                  })
                }}
              </span>
            </template>
          </b-table>
        </b-card>

        <b-card no-body v-else>
          <b-card-body class="px-1 pb-0 pt-1">
            <b-row>
              <b-col xl="3" lg="3" md="3" class="mb-1 align-self-center">
                <b-button-group>
                  <b-button variant="gradient-primary" size="sm" @click="traerMaquinaria" id="act_semSgte">
                    <font-awesome-icon icon="fa-solid fa-arrows-rotate" :spin="loading" />
                  </b-button>
                  <b-tooltip title="Actualizar Tabla" target="act_semSgte" />
                  <b-button v-if="$can('create', 'Pr Fert Programacion')" variant="gradient-primary" size="sm"
                    @click="modal_registro(false)" id="cre_semSgte">
                    <font-awesome-icon icon="fa-solid fa-plus" />
                  </b-button>
                  <b-tooltip title="Crear Registro" target="cre_semSgte" />
                  <b-button variant="gradient-primary" size="sm" v-if="$can('create', 'Pr Fert Programacion')"
                    @click="mostrarModalImportar(false)" v-b-modal.modal-importar id="imp_semSgte">
                    <font-awesome-icon icon="fa-solid fa-file-excel" />
                  </b-button>
                  <b-tooltip title="Importar Registros" target="imp_semSgte" />
                </b-button-group>
              </b-col>
              <b-col xl="9" lg="9" md="9" class="mb-1" align="center">
                <span class="font-weight-bolder font-medium-3"
                  style="vertical-align: -webkit-baseline-middle!important;">{{ `Semana siguiente N°
                  ${this.semana_sig}`
                  }}</span><br>
                <span class="font-weight-bolder font-small-4"
                  style="vertical-align: -webkit-baseline-middle!important;">{{ `Del ${this.inicioSemana_sig} al
                  ${this.finSemana_sig}`
                  }}</span>
              </b-col>
            </b-row>
          </b-card-body>

          <b-table v-if="$can('read', 'Pr Fert Programacion')" ref="tableSemanaActual" responsive hover outlined
            sticky-header="58vh" class="position-relative tablaferti" :items="items" :fields="fields"
            :filter="filter_sig" :filter-included-fields="filterOn" :sort-by.sync="sortBy" :sort-desc.sync="sortDesc"
            :sort-direction="sortDirection" :busy="loading" show-empty
            empty-text="No se encontraron datos en esta tabla."
            emptyFilteredText="No se encontraron datos con los parámetros ingresados.">
            <template #table-busy>
              <div class="text-center text-dark my-1">
                <b-spinner class="align-middle"></b-spinner> &emsp;
                <strong>Obteniendo datos...</strong>
              </div>
            </template>

            <template #cell(acciones)="data">
              <div class="text-nowrap">
                <feather-icon v-if="$can('read', 'Pr Fert Programacion')" :id="`btn_${data.item.id}_detalle`"
                  icon="EyeIcon" size="16" class="mr-1 text-primary" @click="verDetalleSemSgte(data.item)" />
                <b-tooltip title="Ver detalle" :target="`btn_${data.item.id}_detalle`" />

                <feather-icon v-if="$can('authorize', 'Pr Fert Programacion')" :id="`btn_${data.item.id}_autorizar`"
                  icon="UserCheckIcon" size="16" @click="autorizar(data.item)" />
                <b-tooltip title="Autorizar" :target="`btn_${data.item.id}_autorizar`" />

              </div>
            </template>

            <template #cell(estado)="data">
              <b-badge :variant="status[1][parseInt(data.value)]">
                {{ status[0][parseInt(data.value)] }}
              </b-badge>
            </template>

            <template #cell(created)="data">
              <span>
                {{
                  new Date(data.value).toLocaleString('pe-PE', {
                    year: 'numeric',
                    month: '2-digit',
                    day: '2-digit',
                    localeMatcher: 'best fit',
                    hour: '2-digit',
                    minute: '2-digit',
                    hour12: true,
                    timeZone: 'America/Lima'
                  })
                }}
              </span>
            </template>
          </b-table>
        </b-card>
      </b-col>
    </b-row>

    <b-modal id="modal-prevent-closing" v-model="modal_registro_o" ref="my-modal" :title="title_sem"
      ok-title="Registrar" cancel-title="Cancelar" cancel-variant="outline-secondary" :size="loading2 ? 'md' : 'xl'"
      :cancel-disabled="loading2" :ok-disabled="loading2" centered no-close-on-esc no-close-on-backdrop
      @show="resetModal" @hidden="resetModal" @ok="handleOk">

      <div v-if="loading2" align="center">
        <p>Registrando ... </p>
        <b-spinner label="Loading..." variant="primary" />
      </div>
      <validation-observer v-else ref="formularioMaquinaria" #default="{ invalid }">
        <b-form autocomplete="off" @submit.prevent="handleSubmit">
          <b-row>
            <b-col md="4" lg="1">
              <b-form-group label="Semana" label-for="semana">
                <validation-provider #default="{ errors }" name="Semana" vid="semana"
                  rules="required|integer|between:1,52">
                  <b-form-input id="semana" v-model="semana" :state="errors.length > 0 ? false : null" name="semana"
                    @input="asignarInicioFinSemana" disabled />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
            <b-col md="8" lg="3">
              <b-form-group label="Empresa" label-for="empresa">
                <validation-provider #default="{ errors }" name="Empresa" vid="empresa" rules="required">
                  <v-select id="empresa" v-model="empresa" :options="empresas" placeholder="Seleccionar empresa..."
                    @input="asignarTipos" />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
            <b-col md="4" lg="2">
              <b-form-group label="Tipo" label-for="tipo">
                <validation-provider #default="{ errors }" name="Tipo" vid="tipo" rules="required">
                  <v-select id="tipo" v-model="tipo" :options="tipos" placeholder="Seleccione Tipo..."
                    @input="asignarCategoria">
                    <span slot="no-options">No se encontraron datos.</span>
                  </v-select>
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
            <b-col md="4" lg="2">
              <b-form-group label="Categoria" label-for='Categoria'>
                <validation-provider #default="{ errors }" name="Categoria" vid="categoria" rules="required">
                  <v-select id="categoria" v-model="categoria" :options="categorias"
                    placeholder="Seleccionar categoria..." @input="asignarCultivos">
                    <span slot="no-options">No se encontraron datos.</span>
                  </v-select>
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
            <b-col md="4" lg="2">
              <b-form-group :label="label_cultivo" label-for='Cultivo'>
                <validation-provider #default="{ errors }" name="Cultivo" vid="cultivo" rules="required">
                  <v-select id="cultivo" v-model="cultivo" :options="cultivos" placeholder="Seleccionar cultivo..."
                    @input="asignarFundos">
                    <span slot="no-options">No se encontraron datos.</span>
                  </v-select>
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
            <b-col md="6" lg="2">
              <b-form-group :label="label_fundo" label-for="fundo">
                <validation-provider #default="{ errors }" name="Fundo" vid="fundo" rules="required">
                  <v-select id="fundo" v-model="fundo" :options="fundos" placeholder="Seleccionar fundo..."
                    @input="asignarEtapas">
                    <span slot="no-options">No se encontraron datos.</span>
                  </v-select>
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
            <b-col md="6" lg="2">
              <b-form-group :label="label_etapa" label-for="etapa">
                <validation-provider #default="{ errors }" name="Etapa" vid="etapa" rules="required">
                  <v-select id="etapa" v-model="etapa" :options="etapas" placeholder="Seleccionar etapa..."
                    @input="asignarCampos">
                    <span slot="no-options">No se encontraron datos.</span>
                  </v-select>
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
            <b-col md="6" lg="2">
              <b-form-group :label="label_campo" label-for="campo">
                <validation-provider #default="{ errors }" name="Campo" vid="campo" rules="required">
                  <v-select id="campo" v-model="campo" :options="campos" placeholder="Seleccionar campo..."
                    @input="asignarTurnos">
                    <span slot="no-options">No se encontraron datos.</span>
                  </v-select>
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
            <b-col md="6" lg="2">
              <b-form-group :label="label_turno" label-for="turno">
                <validation-provider #default="{ errors }" name="Turno" vid="turno" rules="required">
                  <v-select id="turno" v-model="turno" :options="turnos" placeholder="Seleccionar turno..."
                    @input="asignarCodigoH">
                    <span slot="no-options">No se encontraron datos.</span>
                  </v-select>
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
            <b-col md="4" lg="3">
              <b-form-group label="C.Homologado" label-for="codigo_h">
                <validation-provider #default="{ errors }" name="Codigo Homologado" vid="codigo_h" rules="required">
                  <b-form-input id="codigo_h" v-model="codigo_h" :state="errors.length > 0 ? false : null"
                    name="codigo_h" disabled />
                  <!-- @input="asignarInicioFinSemana" -->
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
            <b-col md="4" v-if="tipo != 'INDIRECTO'" lg="2">
              <b-form-group label="Variedad" label-for="variedad">
                <validation-provider #default="{ errors }" name="Variedad" vid="variedad" rules="required">
                  <b-form-input id="variedad" v-model="variedad" :state="errors.length > 0 ? false : null"
                    name="variedad" disabled />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
            <b-col md="4" v-if="tipo != 'INDIRECTO'" lg="1">
              <b-form-group label="Área" label-for="area">
                <validation-provider #default="{ errors }" name="Área" vid="area" rules="required">
                  <b-form-input id="area" v-model="area" :state="errors.length > 0 ? false : null" name="area"
                    disabled />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
          </b-row>

          <b-row>
            <b-col md="5" lg="2">
              <b-form-group label="Cód. Responsable" label-for="codigo_resp">
                <validation-provider #default="{ errors }" name="Responsable" vid="codigo_resp" rules="required">
                  <b-input-group>
                    <b-form-input id="codigo_resp" v-model="codigo_resp" :state="errors.length > 0 ? false : null"
                      name="codigo_resp" />
                    <b-input-group-append>
                      <b-button variant="primary" class="btn-icon" block @click="buscarResponsable_reg"
                        :disabled="!codigo_resp">
                        &emsp13;
                        <feather-icon v-if="loadingBP" icon="RotateCwIcon" class="spinner" />
                        <feather-icon v-else icon="SearchIcon" />
                        &emsp13;
                      </b-button>
                    </b-input-group-append>
                  </b-input-group>
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
            <b-col md="7" lg="4">
              <b-form-group label="Responsable" label-for="responsable_reg">
                <validation-provider #default="{ errors }" name="Responsable" vid="responsable_reg" rules="required">
                  <b-form-input id="responsable_reg" v-model="responsable_reg" :state="errors.length > 0 ? false : null"
                    name="responsable_reg" disabled />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
          </b-row>

          <b-row>
            <b-col md="5" lg="2">
              <b-form-group label="Cód. Maquinaria" label-for="codigo_maq">
                <validation-provider #default="{ errors }" name="Maquinaria" vid="codigo_maq" rules="required">
                  <b-input-group>
                    <b-form-input id="codigo_maq" v-model="codigo_maq" :state="errors.length > 0 ? false : null"
                      name="codigo_maq" />
                    <b-input-group-append>
                      <b-button variant="primary" class="btn-icon" block @click="buscarMaquinaria"
                        :disabled="!codigo_maq">
                        &emsp13;
                        <feather-icon v-if="loadingBP" icon="RotateCwIcon" class="spinner" />
                        <feather-icon v-else icon="SearchIcon" />
                        &emsp13;
                      </b-button>
                    </b-input-group-append>
                  </b-input-group>
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
            <b-col md="7" lg="4">
              <b-form-group label="Maquinaria" label-for="maquinaria">
                <validation-provider #default="{ errors }" name="Maquinaria" vid="maquinaria" rules="required">
                  <b-form-input id="maquinaria" v-model="maquinaria" :state="errors.length > 0 ? false : null"
                    name="maquinaria" disabled />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>


            <b-col md="5" lg="2">
              <b-form-group label="Cód. Implemento" label-for="codigo_imp">
                <validation-provider #default="{ errors }" name="Implemento" vid="codigo_imp" rules="required">
                  <b-input-group>
                    <b-form-input id="codigo_imp" v-model="codigo_imp" :state="errors.length > 0 ? false : null"
                      name="codigo_imp" />
                    <b-input-group-append>
                      <b-button variant="primary" class="btn-icon" block @click="buscarImplemento"
                        :disabled="!codigo_imp">
                        &emsp13;
                        <feather-icon v-if="loadingBP" icon="RotateCwIcon" class="spinner" />
                        <feather-icon v-else icon="SearchIcon" />
                        &emsp13;
                      </b-button>
                    </b-input-group-append>
                  </b-input-group>
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
            <b-col md="7" lg="4">
              <b-form-group label="Implemento" label-for="implemento">
                <validation-provider #default="{ errors }" name="Implemento" vid="implemento" rules="required">
                  <b-form-input id="implemento" v-model="implemento" :state="errors.length > 0 ? false : null"
                    name="implemento" disabled />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
            <b-col md="5" lg="2">
              <b-form-group label="Cód. Actividad" label-for="codigo_act">
                <validation-provider #default="{ errors }" name="Actividad" vid="codigo_act" rules="required">
                  <b-input-group>
                    <b-form-input id="codigo_act" v-model="codigo_act" :state="errors.length > 0 ? false : null"
                      name="codigo_act" />
                    <b-input-group-append>
                      <b-button variant="primary" class="btn-icon" block @click="buscarActividad"
                        :disabled="!codigo_act">
                        &emsp13;
                        <feather-icon v-if="loadingBP" icon="RotateCwIcon" class="spinner" />
                        <feather-icon v-else icon="SearchIcon" />
                        &emsp13;
                      </b-button>
                    </b-input-group-append>
                  </b-input-group>
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
            <b-col md="7" lg="4">
              <b-form-group label="Actividad" label-for="actividad">
                <validation-provider #default="{ errors }" name="Actividad" vid="actividad" rules="required">
                  <b-form-input id="actividad" v-model="actividad" :state="errors.length > 0 ? false : null"
                    name="actividad" disabled />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
            <b-col md="5" lg="2">
              <b-form-group label="Cód. Labor" label-for="codigo_lab">
                <validation-provider #default="{ errors }" name="Cód. Labor" vid="codigo_lab" rules="required">
                  <b-input-group>
                    <b-form-input id="codigo_lab" v-model="codigo_lab" :state="errors.length > 0 ? false : null"
                      name="codigo_lab" />
                    <b-input-group-append>
                      <b-button variant="primary" class="btn-icon" block @click="buscarLabor" :disabled="!codigo_lab">
                        &emsp13;
                        <feather-icon v-if="loadingBP" icon="RotateCwIcon" class="spinner" />
                        <feather-icon v-else icon="SearchIcon" />
                        &emsp13;
                      </b-button>
                    </b-input-group-append>
                  </b-input-group>
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
            <b-col md="7" lg="4">
              <b-form-group label="Labor" label-for="labor">
                <validation-provider #default="{ errors }" name="labor" vid="labor" rules="required">
                  <b-form-input id="labor" v-model="labor" :state="errors.length > 0 ? false : null" name="labor"
                    disabled />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
          </b-row>

          <b-row align-h="center">
            <b-col md="6" lg="1">
              <b-form-group label="Hora Inicio" label-for="h_ini">
                <validation-provider #default="{ errors }" name="Hora" vid="h_ini" rules="required">
                  <flat-pickr v-model="h_ini" class="form-control" placeholder="H. Inical" :config="{
                    enableTime: true,
                    noCalendar: true,
                    dateFormat: 'H:i',
                    time_24hr: true
                  }">
                  </flat-pickr>
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
            <b-col md="6" lg="1">
              <b-form-group label="Hora Fin" label-for="h_fin">
                <validation-provider #default="{ errors }" name="Hora" vid="h_fin" rules="required">
                  <flat-pickr v-model="h_fin" class="form-control" placeholder="H. Final" :config="{
                    enableTime: true,
                    noCalendar: true,
                    dateFormat: 'H:i',
                    time_24hr: true,
                    minTime: h_ini
                  }">
                  </flat-pickr>
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
            <b-col md="6" lg="1">
              <b-form-group label="Ratio Objetivo" label-for="ratio_obj">
                <validation-provider #default="{ errors }" name="Ratio Objetivo" vid="Ratio Objetivo" rules="required">
                  <b-input-group :state="errors.length > 0 ? false : null" name="Ratio">
                    <b-form-input id="ratio_obj" v-model="ratio_obj" />
                  </b-input-group>
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
            <b-col md="6" lg="1">
              <b-form-group label="Avance Sem" label-for="avance_sem">
                <b-input-group>
                  <b-form-input id="avance_sem" v-model="avance_sem" />
                </b-input-group>
              </b-form-group>
            </b-col>

            <b-col md="3" lg="1">
              <b-form-group label="Lunes" label-for="lunes">
                <!-- <b-form-input id="lunes" v-model="lunes" placeholder="0.0" /> -->
                <input type="checkbox" v-model="lunes">
              </b-form-group>
            </b-col>
            <b-col md="3" lg="1">
              <b-form-group label="Martes" label-for="martes">
                <!-- <b-form-input id="martes" v-model="martes" placeholder="0.0" /> -->
                <input type="checkbox" v-model="martes">
              </b-form-group>
            </b-col>
            <b-col md="3" lg="1">
              <b-form-group label="Miércoles" label-for="miercoles">
                <!-- <b-form-input id="miercoles" v-model="miercoles" placeholder="0.0" /> -->
                <input type="checkbox" v-model="miercoles">
              </b-form-group>
            </b-col>
            <b-col md="3" lg="1">
              <b-form-group label="Jueves" label-for="jueves">
                <!-- <b-form-input id="jueves" v-model="jueves" placeholder="0.0" /> -->
                <input type="checkbox" v-model="jueves">
              </b-form-group>
            </b-col>
            <b-col md="3" lg="1">
              <b-form-group label="Viernes" label-for="viernes">
                <!-- <b-form-input id="viernes" v-model="viernes" placeholder="0.0" /> -->
                <input type="checkbox" v-model="viernes">
              </b-form-group>
            </b-col>
            <b-col md="3" lg="1">
              <b-form-group label="Sábado" label-for="sabado">
                <!-- <b-form-input id="sabado" v-model="sabado" placeholder="0.0" /> -->
                <input type="checkbox" v-model="sabado">
              </b-form-group>
            </b-col>
            <b-col md="3" lg="1">
              <b-form-group label="Domingo" label-for="domingo">
                <!-- <b-form-input id="domingo" v-model="domingo" placeholder="0.0" /> -->
                <input type="checkbox" v-model="domingo">
              </b-form-group>
            </b-col>
            <b-col lg="10">
              <b-form-group label="Comentarios" label-for="comentario">
                <b-form-textarea id="comentario" v-model="comentario" name="comentario" />
              </b-form-group>
            </b-col>
          </b-row>
        </b-form>
      </validation-observer>
    </b-modal>

    <b-modal id="modal-editar" ref="modal-editar" v-model="estadoModalEditar" title="Editar Registro" ok-title="Editar"
      cancel-title="Cancelar" cancel-variant="outline-secondary" :size="loadingEDI ? 'md' : 'xl'"
      :cancel-disabled="loadingEDI" :ok-disabled="loadingEDI" centered no-close-on-esc no-close-on-backdrop @show=""
      @hidden="" @ok="EditarRegistro">
      <div v-if="loading2" align="center">
        <p>Editando ... </p>
        <b-spinner label="Loading..." variant="primary" />
      </div>
      <validation-observer v-else ref="formularioEditarMaquinaria" #default="{ invalid }">
        <b-form autocomplete="off" @submit.prevent="">
          <b-row>
            <b-col md="4" lg="1">
              <b-form-group label="Semana" label-for="semana_e">
                <validation-provider #default="{ errors }" name="Semana" vid="semana_e"
                  rules="required|integer|between:1,52">
                  <b-form-input id="semana_e" v-model="semana" :state="errors.length > 0 ? false : null" name="semana"
                    @input="asignarInicioFinSemana" />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
            <b-col md="8" lg="3">
              <b-form-group label="Empresa" label-for="empresa_e">
                <validation-provider #default="{ errors }" name="Empresa" vid="empresa_e" rules="required">
                  <v-select id="empresa_e" v-model="empresa" :options="empresas" placeholder="Seleccionar empresa..."
                    @input="asignarTipos" />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
            <b-col md="4" lg="2">
              <b-form-group label="Tipo" label-for="tipo_e">
                <validation-provider #default="{ errors }" name="Tipo" vid="tipo_e" rules="required">
                  <v-select id="tipo_e" v-model="tipo" :options="tipos" placeholder="Seleccione Tipo..."
                    @input="asignarCategoria">
                    <span slot="no-options">No se encontraron datos.</span>
                  </v-select>
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
            <b-col md="4" lg="2">
              <b-form-group label="Categoria" label-for='categoria_e'>
                <validation-provider #default="{ errors }" name="Categoria" vid="categoria_e" rules="required">
                  <v-select id="categoria_e" v-model="categoria" :options="categorias"
                    placeholder="Seleccionar categoria..." @input="asignarCultivos">
                    <span slot="no-options">No se encontraron datos.</span>
                  </v-select>
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
            <b-col md="4" lg="2">
              <b-form-group :label="label_cultivo" label-for="cultivo_e">
                <validation-provider #default="{ errors }" name="Cultivo" vid="cultivo_e" rules="required">
                  <v-select id="cultivo_e" v-model="cultivo" :options="cultivos" placeholder="Seleccionar cultivo..."
                    @input="asignarFundos">
                    <span slot="no-options">No se encontraron datos.</span>
                  </v-select>
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
            <b-col md="4" lg="2">
              <b-form-group :label="label_fundo" label-for="fundo_e">
                <validation-provider #default="{ errors }" name="Fundo" vid="fundo_e" rules="required">
                  <v-select id="fundo_e" v-model="fundo" :options="fundos" placeholder="Seleccionar fundo..."
                    @input="asignarEtapas">
                    <span slot="no-options">No se encontraron datos.</span>
                  </v-select>
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
            <b-col md="6" lg="2">
              <b-form-group :label="label_etapa" label-for="etapa_e">
                <validation-provider #default="{ errors }" name="Etapa" vid="etapa_e" rules="required">
                  <v-select id="etapa_e" v-model="etapa" :options="etapas" placeholder="Seleccionar etapa..."
                    @input="asignarCampos">
                    <span slot="no-options">No se encontraron datos.</span>
                  </v-select>
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
            <b-col md="6" lg="2">
              <b-form-group :label="label_campo" label-for="campo_e">
                <validation-provider #default="{ errors }" name="Campo" vid="campo_e" rules="required">
                  <v-select id="campo_e" v-model="campo" :options="campos" placeholder="Seleccionar campo..."
                    @input="asignarTurnos">
                    <span slot="no-options">No se encontraron datos.</span>
                  </v-select>
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
            <b-col md="6" lg="2">
              <b-form-group :label="label_turno" label-for="turno_e">
                <validation-provider #default="{ errors }" name="Turno" vid="turno_e" rules="required">
                  <v-select id="turno_e" v-model="turno" :options="turnos" placeholder="Seleccionar turno..."
                    @input="asignarCodigoH">
                    <span slot="no-options">No se encontraron datos.</span>
                  </v-select>
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
            <b-col md="6" lg="3">
              <b-form-group label="C. Homologado" label-for="codigo_h_e">
                <validation-provider #default="{ errors }" name="Codigo Homologado" vid="codigo_h_e" rules="required">
                  <b-form-input id="codigo_h_e" v-model="codigo_h" :state="errors.length > 0 ? false : null"
                    name="codigo_h_e" disabled />
                  <!-- @input="asignarInicioFinSemana" -->
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
            <b-col md="6" v-if="tipo != 'INDIRECTO'" lg="2">
              <b-form-group label="Variedad" label-for="variedad_e">
                <validation-provider #default="{ errors }" name="Variedad" vid="variedad_e" rules="required">
                  <b-form-input id="variedad_e" v-model="variedad" :state="errors.length > 0 ? false : null"
                    name="variedad" disabled />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
            <b-col md="6" v-if="tipo != 'INDIRECTO'" lg="1">
              <b-form-group label="Área" label-for="area_e">
                <validation-provider #default="{ errors }" name="Área" vid="area_e" rules="required">
                  <b-form-input id="area_e" v-model="area" :state="errors.length > 0 ? false : null" name="area"
                    disabled />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
          </b-row>
          <!-- Responsable y Maquinaria & Actividad y Labor-->
          <b-row>
            <b-col md="5" lg="2">
              <b-form-group label="Id Responsable" label-for="codigo_resp_e">
                <validation-provider #default="{ errors }" name="Responsable" vid="codigo_resp_e" rules="required">
                  <b-input-group>
                    <b-form-input id="codigo_resp_e" v-model="codigo_resp" :state="errors.length > 0 ? false : null"
                      name="codigo_resp_e" />
                    <b-input-group-append>
                      <b-button variant="primary" class="btn-icon" block @click="buscarResponsable_reg"
                        :disabled="!codigo_resp">
                        &emsp13;
                        <feather-icon v-if="loadingBP" icon="RotateCwIcon" class="spinner" />
                        <feather-icon v-else icon="SearchIcon" />
                        &emsp13;
                      </b-button>
                    </b-input-group-append>
                  </b-input-group>
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
            <b-col md="7" lg="4">
              <b-form-group label="Responsable" label-for="responsable_reg">
                <validation-provider #default="{ errors }" name="Responsable" vid="responsable_reg" rules="required">
                  <b-form-input id="responsable_reg" v-model="responsable_reg" :state="errors.length > 0 ? false : null"
                    name="responsable_reg" disabled />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
            <b-col md="5" lg="2">
              <b-form-group label="Cód. Maquinaria" label-for="codigo_maq">
                <validation-provider #default="{ errors }" name="Código Maquinaria" vid="codigo_maq" rules="required">
                  <b-input-group>
                    <b-form-input id="codigo_maq" v-model="codigo_maq" :state="errors.length > 0 ? false : null"
                      name="codigo_maq" />
                    <b-input-group-append>
                      <b-button variant="primary" class="btn-icon" block @click="buscarMaquinaria"
                        :disabled="!codigo_maq">
                        &emsp13;
                        <feather-icon v-if="loadingBP" icon="RotateCwIcon" class="spinner" />
                        <feather-icon v-else icon="SearchIcon" />
                        &emsp13;
                      </b-button>
                    </b-input-group-append>
                  </b-input-group>
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
            <b-col md="7" lg="4">
              <b-form-group label="Maquinaria" label-for="maquinaria">
                <validation-provider #default="{ errors }" name="Maquinaria" vid="maquinaria" rules="required">
                  <b-form-input id="maquinaria" v-model="maquinaria" :state="errors.length > 0 ? false : null"
                    name="maquinaria" disabled />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
            <b-col md="5" lg="2">
              <b-form-group label="Cód. Actividad" label-for="codigo_act">
                <validation-provider #default="{ errors }" name="Actividad" vid="codigo_act" rules="required">
                  <b-input-group>
                    <b-form-input id="codigo_act" v-model="codigo_act" :state="errors.length > 0 ? false : null"
                      name="codigo_act" />
                    <b-input-group-append>
                      <b-button variant="primary" class="btn-icon" block @click="buscarActividad"
                        :disabled="!codigo_act">
                        &emsp13;
                        <feather-icon v-if="loadingBP" icon="RotateCwIcon" class="spinner" />
                        <feather-icon v-else icon="SearchIcon" />
                        &emsp13;
                      </b-button>
                    </b-input-group-append>
                  </b-input-group>
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
            <b-col md="7" lg="4">
              <b-form-group label="Actividad" label-for="actividad">
                <validation-provider #default="{ errors }" name="Actividad" vid="actividad" rules="required">
                  <b-form-input id="actividad" v-model="actividad" :state="errors.length > 0 ? false : null"
                    name="actividad" disabled />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
            <b-col md="5" lg="2">
              <b-form-group label="Cód. Labor" label-for="codigo_lab">
                <validation-provider #default="{ errors }" name="Código Labor" vid="codigo_lab" rules="required">
                  <b-input-group>
                    <b-form-input id="codigo_lab" v-model="codigo_lab" :state="errors.length > 0 ? false : null"
                      name="codigo_lab" />
                    <b-input-group-append>
                      <b-button variant="primary" class="btn-icon" block @click="buscarLabor" :disabled="!codigo_lab">
                        &emsp13;
                        <feather-icon v-if="loadingBP" icon="RotateCwIcon" class="spinner" />
                        <feather-icon v-else icon="SearchIcon" />
                        &emsp13;
                      </b-button>
                    </b-input-group-append>
                  </b-input-group>
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
            <b-col md="7" lg="4">
              <b-form-group label="Labor" label-for="labor">
                <validation-provider #default="{ errors }" name="labor" vid="labor" rules="required">
                  <b-form-input id="labor" v-model="labor" :state="errors.length > 0 ? false : null" name="labor"
                    disabled />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
          </b-row>
          <!-- Responsable y Maquinaria & Fin Actividad y Labor -->

          <b-row align-h="center">
            <b-col md="6" lg="1">
              <b-form-group label="Hora Inicio" label-for="h_ini">
                <validation-provider #default="{ errors }" name="Hora" vid="h_ini" rules="required">
                  <flat-pickr v-model="h_ini" class="form-control" placeholder="H. Inical" :config="{
                    enableTime: true,
                    noCalendar: true,
                    dateFormat: 'H:i',
                    time_24hr: true
                  }">
                  </flat-pickr>
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
            <b-col md="6" lg="1">
              <b-form-group label="Hora Fin" label-for="h_fin">
                <validation-provider #default="{ errors }" name="Hora" vid="h_fin" rules="required">
                  <flat-pickr v-model="h_fin" class="form-control" placeholder="H. Final" :config="{
                    enableTime: true,
                    noCalendar: true,
                    dateFormat: 'H:i',
                    time_24hr: true,
                    minTime: h_ini
                  }">
                  </flat-pickr>
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
            <b-col md="6" lg="1">
              <b-form-group label="Ratio Objetivo" label-for="ratio_obj">
                <validation-provider #default="{ errors }" name="Ratio Objetivo" vid="ratio_obj" rules="required">
                  <b-input-group>
                    <b-form-input id="ratio_obj" v-model="ratio_obj" :state="errors.length > 0 ? false : null"
                      name="ratio_obj" />
                  </b-input-group>
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
            <b-col md="6" lg="1">
              <b-form-group label="Avance Sem" label-for="avance_sem">
                <validation-provider #default="{ errors }" name="Ratio Objetivo" vid="avance_sem" rules="required">
                  <b-input-group>
                    <b-form-input id="avance_sem" v-model="avance_sem" :state="errors.length > 0 ? false : null"
                      name="avance_sem" />
                  </b-input-group>
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
            <b-col md="3" lg="1">
              <b-form-group label="Lunes" label-for="lunes">
                <!-- <b-form-input id="lunes" v-model="lunes" placeholder="0.0" /> -->
                <input type="checkbox" v-model="lunes">
              </b-form-group>
            </b-col>
            <b-col md="3" lg="1">
              <b-form-group label="Martes" label-for="martes">
                <!-- <b-form-input id="martes" v-model="martes" placeholder="0.0" /> -->
                <input type="checkbox" v-model="martes">
              </b-form-group>
            </b-col>
            <b-col md="3" lg="1">
              <b-form-group label="Miércoles" label-for="miercoles">
                <!-- <b-form-input id="miercoles" v-model="miercoles" placeholder="0.0" /> -->
                <input type="checkbox" v-model="miercoles">
              </b-form-group>
            </b-col>
            <b-col md="3" lg="1">
              <b-form-group label="Jueves" label-for="jueves">
                <!-- <b-form-input id="jueves" v-model="jueves" placeholder="0.0" /> -->
                <input type="checkbox" v-model="jueves">
              </b-form-group>
            </b-col>
            <b-col md="3" lg="1">
              <b-form-group label="Viernes" label-for="viernes">
                <!-- <b-form-input id="viernes" v-model="viernes" placeholder="0.0" /> -->
                <input type="checkbox" v-model="viernes">
              </b-form-group>
            </b-col>
            <b-col md="3" lg="1">
              <b-form-group label="Sábado" label-for="sabado">
                <!-- <b-form-input id="sabado" v-model="sabado" placeholder="0.0" /> -->
                <input type="checkbox" v-model="sabado">
              </b-form-group>
            </b-col>
            <b-col md="3" lg="1">
              <b-form-group label="Domingo" label-for="domingo">
                <!-- <b-form-input id="domingo" v-model="domingo" placeholder="0.0" /> -->
                <input type="checkbox" v-model="domingo">
              </b-form-group>
            </b-col>
            <b-col lg="10">
              <b-form-group label="Comentarios" label-for="comentario">
                <b-form-textarea id="comentario" v-model="comentario" name="comentario" />
              </b-form-group>
            </b-col>
          </b-row>
        </b-form>
      </validation-observer>
    </b-modal>

    <b-modal id="modal-importar" ref="modal-importar" title="Importar Datos Masivos" ok-title="Importar"
      cancel-title="Cancelar" cancel-variant="outline-secondary" size="md" :cancel-disabled="loadingIMP"
      :ok-disabled="loadingIMP || !archivo_excel" centered no-close-on-esc no-close-on-backdrop @ok="importarOk">
      <div v-if="loadingIMP" align="center">
        <p>Importando datos ... </p>
        <b-spinner label="Loading..." variant="primary" />
      </div>
      <validation-observer v-else ref="formularioImportar" #default="{ invalid }">
        <b-form autocomplete="off" @submit.prevent="enviarFile">
          <b-row>
            <b-col lg="12">
              <b-form-group label="Archivo" label-for="archivo">
                <validation-provider #default="{ errors }" name="Archivo" vid="archivo" rules="required">
                  <b-form-file id="archivo" accept=".xlsx" placeholder="Seleccionar Archivo Excel (.xlsx)"
                    v-model="archivo_excel" ref="fileinput">
                    <template slot="file-name" slot-scope="{ names }">
                      <b-badge variant="primary">
                        {{ names[0] }}
                      </b-badge>
                    </template>
                  </b-form-file>
                </validation-provider>
              </b-form-group>
            </b-col>
          </b-row>
        </b-form>
      </validation-observer>
    </b-modal>

    <b-modal id="modal-respuesta" ref="modal-respuesta" v-model="estadoModalRespuesta" title="Respuesta"
      ok-title="Aceptar" ok-only size="md" no-close-on-esc no-close-on-backdrop @show="" @hidden="" scrollable>
      <b-row>
        <b-col lg="12">
          <span>Se realizaron la creación de {{ respuestaRegistrosTotal }} registros satisfactoriamente.</span><br><br>
          <span>Se encontraron {{ respuestaErrores.length }} registros con errores:</span><br><br>
          <div v-for="error in respuestaErrores" :key="error.contador2">
            <div class="mb-1">
              <span>Codigo homologado: {{ error.cod_homologado }}</span><br>
              <span>Error: {{ error.error }}.</span>
            </div>
          </div>


        </b-col>
      </b-row>
    </b-modal>

    <b-modal id="modal-select2" v-model="modalEditarEstadoShow" no-close-on-esc no-close-on-backdrop
      cancel-variant="secondary" ok-title="Actualizar" :ok-disabled="!estado_aprobar" cancel-title="Cancelar" centered
      title="Autorizar registro" @ok="aprobar">
      <b-form>
        <b-form-group label="Estado" label-for="estado_editar">
          <v-select id="estado_editar" v-model="estado_aprobar" :options="estados" :reduce="estados => estados.value"
            label="text" key="value" placeholder="Seleccionar estado..." />
        </b-form-group>
      </b-form>
    </b-modal>
  </div>
</template>

<script>

import axiosIns from '../../libs/axios'
import vSelect from 'vue-select'
import {
  BBadge,
  BButton,
  BCard,
  BCardBody,
  BForm,
  BFormGroup,
  BFormInput,
  BFormCheckbox,
  BFormSelect,
  BModal,
  BPagination,
  BSpinner,
  BTable,
  BRow,
  BCol,
  BDropdownDivider,
  BFormFile,
  VBModal,
  BTooltip,
  BInputGroup,
  BInputGroupAppend,
  BInputGroupPrepend, BFormTextarea, BLink, BButtonGroup,
} from 'bootstrap-vue'
import { ValidationProvider, ValidationObserver, localize } from 'vee-validate'
import { required, double, max, between, integer } from '@validations'
import ToastificationContent from '@core/components/toastification/ToastificationContent'
import flatPickr from 'vue-flatpickr-component';
import 'flatpickr/dist/flatpickr.css';

export default {
  components: {
    flatPickr,
    BCard,
    BCardBody,
    BTable,
    BSpinner,
    BBadge,
    BFormGroup,
    BFormSelect,
    BPagination,
    BButton,
    BFormCheckbox,
    BFormInput,
    BModal,
    VBModal,
    BForm,
    BCol,
    BRow,
    BDropdownDivider,
    BFormFile,
    BTooltip,
    BInputGroup,
    BInputGroupAppend,
    BInputGroupPrepend,
    BFormTextarea,
    BLink,
    BButtonGroup,

    vSelect,

    ValidationProvider,
    ValidationObserver,
  },
  directives: {
    'b-modal': VBModal,
  },
  data: () => ({
    id_user: JSON.parse(localStorage.getItem('userData')).id,
    inicioSemana: null,
    finSemana: null,
    semana: null,
    cultivo: null,
    tipo: null,
    empresa: null,
    categoria: null,
    fundo: null,
    etapa: null,
    campo: null,
    turno: null,
    codigo_h: null,
    variedad: null,
    area: null,
    codigo_maq: null,
    maquinaria: null,
    codigo_resp: null,
    responsable_reg: null,
    codigo_act: null,
    actividad: null,
    codigo_imp: null,
    implemento: null,
    codigo_lab: null,
    labores: [],
    labor: null,
    h_ini: null,
    h_fin: null,
    ratio_obj: null,
    avance_sem: null,
    title_sem: null,

    lunes: null,
    martes: null,
    miercoles: null,
    jueves: null,
    viernes: null,
    sabado: null,
    domingo: null,

    loading: false,
    loading2: false,
    loadingBP: false,
    loadingIMP: false,
    loadingEDI: false,

    estadoModalEditar: false,
    loadingExp: false,
    modal_registro_o: false,
    respuestaErrores: [],


    estadoModalRespuesta: false,
    respuestaRegistrosTotal: 0,


    modalEditarEstadoShow: false,
    items: [],
    perPage: 5,
    pageOptions: [5, 10, 15, 30],
    totalRows: 0,
    currentPage: 1,
    sortBy: 'id',
    sortDesc: true,
    sortDirection: 'desc',
    filter: null,
    filter_sig: null,
    filterOn: ['semana'],

    fields: [
      {
        key: 'acciones',
        label: '# ',
        class: 'text-nowrap text-center',
        stickyColumn: true,
      },
      {
        key: 'estado',
        label: 'estado',
        class: 'text-nowrap text-center',
        sortable: true,
      },
      {
        key: 'semana',
        label: 'semana',
        class: 'text-nowrap text-center',
        sortable: true,
      },
      {
        key: 'tipo',
        label: 'tipo',
        class: 'text-nowrap text-center',
        sortable: true,
      },
      {
        key: 'empresa',
        label: 'empresa',
        class: 'text-nowrap text-center',
        sortable: true,
      },
      {
        key: 'cultivo',
        label: 'Cultivo/Categoria',
        class: 'text-nowrap text-center',
        sortable: true,
      },
      {
        key: 'fundo',
        label: 'fundo/área',
        class: 'text-nowrap text-center',
        sortable: true,
      },
      {
        key: 'version',
        label: 'versión',
        class: 'text-nowrap text-center',
        sortable: true,
      },
      {
        key: 'created',
        label: 'Fecha - Hora',
        class: 'text-nowrap text-center',
        sortable: true,
      },
    ],

    fields_detalle_SemAct: [
      {
        key: 'acciones',
        label: '# ',
        class: 'text-nowrap text-center',
      },
      {
        key: 'estado',
        label: 'estado',
        class: 'text-nowrap text-center',
        sortable: true,
      },
      {
        key: 'etapa',
        label: 'etapa/sub área',
        class: 'text-nowrap text-center',
        sortable: true,
      },
      {
        key: 'campo',
        label: 'campo/sub área',
        class: 'text-nowrap text-center',
        sortable: true,
      },
      {
        key: 'turno',
        label: 'turno/sub área',
        class: 'text-nowrap text-center',
        sortable: true,
      },
      {
        key: 'variedad',
        label: 'variedad',
        class: 'text-nowrap text-center',
        sortable: true,
      },
      {
        key: 'area',
        label: 'área',
        class: 'text-nowrap text-center',
        sortable: true,
      },
      {
        key: 'cod_maquinaria',
        label: 'Cód. Maquinaria',
        class: 'text-nowrap text-center',
        sortable: true,
      },
      {
        key: 'maquinaria',
        label: 'maquinaria',
        class: 'text-nowrap text-center',
        sortable: true,
      },
      {
        key: 'cod_actividad',
        label: 'Cód. Actividad',
        class: 'text-nowrap text-center',
        sortable: true,
      },
      {
        key: 'actividad',
        label: 'actividad',
        class: 'text-nowrap text-center',
        sortable: true,
      },
      {
        key: 'cod_labor',
        label: 'Cód. Labor',
        class: 'text-nowrap text-center',
        sortable: true,
      },
      {
        key: 'labor',
        label: 'Labor',
        class: 'text-nowrap text-center',
        sortable: true,
      },
      {
        key: 'hora_ini',
        label: 'H. inicio',
        class: 'text-nowrap text-center',
        sortable: true,
      },
      {
        key: 'hora_fin',
        label: 'H. Final',
        class: 'text-nowrap text-center',
        sortable: true,
      },
      {
        key: 'lun',
        label: 'lun',
        class: 'text-nowrap text-center',
        sortable: true,
      },
      {
        key: 'mar',
        label: 'mar',
        class: 'text-nowrap text-center',
        sortable: true,
      },
      {
        key: 'mie',
        label: 'mie',
        class: 'text-nowrap text-center',
        sortable: true,
      },
      {
        key: 'jue',
        label: 'jue',
        class: 'text-nowrap text-center',
        sortable: true,
      },
      {
        key: 'vie',
        label: 'vie',
        class: 'text-nowrap text-center',
        sortable: true,
      },
      {
        key: 'sab',
        label: 'sab',
        class: 'text-nowrap text-center',
        sortable: true,
      },
      {
        key: 'dom',
        label: 'dom',
        class: 'text-nowrap text-center',
        sortable: true,
      },
      {
        key: 'comentarios',
        label: 'comentario',
        class: 'text-nowrap text-center',
        sortable: true,
      },
    ],

    status: [
      {
        0: 'Pendiente',
        1: 'Revisado',
        2: 'Aprobado',
        3: 'Observado',
        4: 'Desaprobado',
      },
      {
        0: 'light-info',
        1: 'light-dark',
        2: 'light-success',
        3: 'light-warning',
        4: 'light-danger',
      }
    ],

    estados: [
      { value: '1', text: "Dar visto bueno" },
    ],

    estado_aprobar: null,

    archivo_excel: null,
    dataEmpresa: [],
    categorias: [],
    empresas: [],
    tipos: [],
    cultivos: [],
    fundos: [],
    etapas: [],
    campos: [],
    turnos: [],
    parametros: [],

    spd: [],
    dia: null,
    hora: null,

    comentario: null,

    semana_sig: null,
    inicioSemana_sig: null,
    finSemana_sig: null,

    mostrarSemAct: false,
    mostrarSemSgte: false,
    items_sem_act: [],
    items_sem_sgte: [],
    responsable: [],

    empresaFiltro: null,
    empresasFiltro: [],
    semanaFiltro: null,
    semanasFiltro: [],
    cultivoFiltro: null,
    cultivosFiltro: [],

    notDuplicados: [],

    dataAutorizar: null,

    semanaActual: true,
    semanaEnviar: null,

    required,
    double,
    max,
    between,
    integer,
  }),
  computed: {
    label_cultivo: function () {
      if (this.tipo == "INDIRECTO") {
        return 'Área'
      } else {
        return 'Cultivo'
      }
    },
    label_fundo: function () {
      if (this.tipo == "INDIRECTO") {
        return 'Sub Área'
      } else {
        return 'Fundo'
      }
    },
    label_etapa: function () {
      if (this.tipo == "INDIRECTO") {
        return 'Sub Área'
      } else {
        return 'Etapa'
      }
    },
    label_campo: function () {
      if (this.tipo == "INDIRECTO") {
        return 'Sub Área'
      } else {
        return 'Campo'
      }
    },
    label_turno: function () {
      if (this.tipo == "INDIRECTO") {
        return 'Sub Área'
      } else {
        return 'Turno'
      }
    }
  },

  async mounted() {
    await this.buscarResponsable();
    await this.dataInicial();
    await this.traerDataEmpresa();
    await this.traerMaquinaria();
    localize("es");

  },
  methods: {
    cPaginacion(filteredItems) {
      this.totalRows = filteredItems.length
      this.currentPage = 1
    },

    mostrarNotificacion(titulo, icono, texto, variante, tiempo) {
      this.$toast({
        component: ToastificationContent,
        props: {
          title: titulo,
          icon: icono,
          text: texto,
          variant: variante
        }
      },
        {
          timeout: tiempo,
          position: 'top-center',
        })
    },

    buscarResponsable() {
      return new Promise(resolve => {
        const yo = this
        yo.loading = true
        const config = {
          method: 'get',
          url: '/pagricolas/consulta_responsable/?id=' + yo.id_user
        }
        axiosIns(config)
          .then(function (response) {
            if (response.status === 200) {
              yo.responsable = response.data
            }
          })
          .catch(function (error) {
            console.log(error);
            yo.mostrarNotificacion('¡Advertencia!', 'AlertTriangleIcon', "No se encontro Usuario.", 'warning', 2000)
          })
          .finally(function () {
            resolve()
          })
      });
    },

    numeroDeSemana(fecha) {
      const DIA_EN_MILISEGUNDOS = 1000 * 60 * 60 * 24, DIAS_QUE_TIENE_UNA_SEMANA = 7, JUEVES = 4;

      fecha = new Date(Date.UTC(fecha.getFullYear(), fecha.getMonth(), fecha.getDate()));

      let diaDeLaSemana = fecha.getUTCDay(); // Domingo es 0, sábado es 6
      if (diaDeLaSemana === 0) {
        diaDeLaSemana = 7;
      }

      fecha.setUTCDate(fecha.getUTCDate() - diaDeLaSemana + JUEVES);

      const inicioDelAnio = new Date(Date.UTC(fecha.getUTCFullYear(), 0, 1));

      const diferenciaDeFechasEnMilisegundos = fecha - inicioDelAnio;

      return {
        n_semana: Math.ceil(((diferenciaDeFechasEnMilisegundos / DIA_EN_MILISEGUNDOS) + 1) / DIAS_QUE_TIENE_UNA_SEMANA),
        inicio: new Date(fecha.getFullYear(), fecha.getMonth(), fecha.getDate() - fecha.getDay() + 1),
        fin: new Date(fecha.getFullYear(), fecha.getMonth(), fecha.getDate() + 7 - fecha.getDay()),
      }
    },

    dataInicial() {
      const spd = this.numeroDeSemana(new Date())
      this.semana = spd.n_semana
      this.inicioSemana = spd.inicio.toLocaleString('pe-PE', {
        month: 'long',
        day: '2-digit',
        year: 'numeric',
        localeMatcher: 'best fit',
        timeZone: 'America/Lima'
      })
      this.finSemana = spd.fin.toLocaleString('pe-PE', {
        month: 'long',
        day: '2-digit',
        year: 'numeric',
        localeMatcher: 'best fit',
        timeZone: 'America/Lima'
      })

      this.semana_sig = spd.n_semana + 1
      spd.inicio.setDate(spd.inicio.getDate() + 7)
      spd.fin.setDate(spd.fin.getDate() + 7)

      this.inicioSemana_sig = spd.inicio.toLocaleString('pe-PE', {
        month: 'long',
        day: '2-digit',
        year: 'numeric',
        localeMatcher: 'best fit',
        timeZone: 'America/Lima'
      })
      this.finSemana_sig = spd.fin.toLocaleString('pe-PE', {
        month: 'long',
        day: '2-digit',
        year: 'numeric',
        localeMatcher: 'best fit',
        timeZone: 'America/Lima'
      })

      this.filter = this.semana.toString()
      this.filter_sig = this.semana_sig.toString()
    },

    traerDataEmpresa() {
      const yo = this
      const config = {
        method: 'get',
        url: '/pagricolas/turnos/'
      }
      axiosIns(config)
        .then(function (response) {
          if (response.status === 200) {
            yo.dataEmpresa = response.data['data']
            for (let value of yo.dataEmpresa) {
              yo.empresas.push(value.sociedad)
            }
            yo.empresas = [...new Set(yo.empresas)].sort()
          }
        })
        .catch(function (error) {
          console.log(error);
        }).finally(function () {
        })


    },

    limpiar() {
      const yo = this
      yo.codigo_h = null
      yo.variedad = null
      yo.area = null
      yo.codigo_resp = null
      yo.responsable_reg = null
      yo.codigo_maq = null
      yo.maquinaria = null
      yo.codigo_act = null
      yo.actividad = null
      yo.codigo_lab = null
      yo.labor = null
    },

    asignarTipos() {
      const yo = this
      yo.categorias = []
      yo.categoria = null
      yo.tipo = null
      yo.tipos = []
      yo.cultivos = []
      yo.cultivo = null
      yo.fundos = []
      yo.fundo = null
      yo.etapas = []
      yo.etapa = null
      yo.campos = []
      yo.campo = null
      yo.turnos = []
      yo.turno = null
      yo.limpiar()
      for (let value of yo.dataEmpresa) {
        if (this.empresa == value.sociedad) {
          yo.tipos.push(value.tipo)
        }
      }
      yo.tipos = [... new Set(yo.tipos)]
    },

    asignarCategoria() {
      const yo = this
      yo.categorias = []
      yo.categoria = null
      yo.cultivos = []
      yo.cultivo = null
      yo.fundos = []
      yo.fundo = null
      yo.etapas = []
      yo.etapa = null
      yo.campos = []
      yo.campo = null
      yo.turnos = []
      yo.turno = null
      yo.limpiar()
      for (let value of yo.dataEmpresa) {
        if (value.sociedad === yo.empresa && yo.tipo === value.tipo) {
          yo.categorias.push(value.categoria)
        }
      }
      yo.categorias = [... new Set(yo.categorias)]
    },

    asignarCultivos() {
      const yo = this
      yo.cultivos = []
      yo.cultivo = null
      yo.fundos = []
      yo.fundo = null
      yo.etapas = []
      yo.etapa = null
      yo.campos = []
      yo.campo = null
      yo.turnos = []
      yo.turno = null
      yo.limpiar()

      for (let value of yo.dataEmpresa) {
        if (value.sociedad === yo.empresa && yo.tipo === value.tipo && yo.categoria === value.categoria) {
          yo.cultivos.push(value.area_cultivo)
        }
      }
      yo.cultivos = [... new Set(yo.cultivos)]
    },

    asignarFundos() {
      const yo = this
      yo.fundos = []
      yo.fundo = null
      yo.etapas = []
      yo.etapa = null
      yo.campos = []
      yo.campo = null
      yo.turnos = []
      yo.turno = null
      yo.limpiar()

      for (let value of yo.dataEmpresa) {
        if (value.sociedad === yo.empresa && yo.tipo === value.tipo && yo.categoria === value.categoria && value.area_cultivo === yo.cultivo) {
          yo.fundos.push(value.fundo)
        }
      }
      yo.fundos = [... new Set(yo.fundos)]
    },

    asignarEtapas() {
      const yo = this
      yo.etapas = []
      yo.etapa = null
      yo.campos = []
      yo.campo = null
      yo.turnos = []
      yo.turno = null
      yo.limpiar()

      for (let value of yo.dataEmpresa) {
        if (value.sociedad === yo.empresa && yo.tipo === value.tipo && yo.categoria === value.categoria && value.area_cultivo === yo.cultivo && value.fundo === yo.fundo) {
          yo.etapas.push(value.etapa)
        }
      }
      yo.etapas = [... new Set(yo.etapas)]
    },

    asignarCampos() {
      const yo = this
      yo.campos = []
      yo.campo = null
      yo.turnos = []
      yo.turno = null
      yo.limpiar()
      for (let value of yo.dataEmpresa) {
        if (value.sociedad === yo.empresa && yo.tipo === value.tipo && yo.categoria === value.categoria && value.area_cultivo === yo.cultivo && value.fundo === yo.fundo && value.etapa === yo.etapa) {
          yo.campos.push(value.campo)
        }
      }
      yo.campos = [... new Set(yo.campos)]
    },

    asignarTurnos() {
      const yo = this
      yo.turnos = []
      yo.turno = null
      yo.limpiar()
      for (let value of yo.dataEmpresa) {
        if (value.sociedad === yo.empresa && yo.tipo === value.tipo && yo.categoria === value.categoria && value.area_cultivo === yo.cultivo && value.fundo === yo.fundo && value.etapa === yo.etapa && value.campo === yo.campo) {
          yo.turnos.push(value.turno)
        }
      }
      yo.turnos = [... new Set(yo.turnos)]
    },

    asignarCodigoH() {
      const yo = this
      yo.limpiar()
      for (let value of yo.dataEmpresa) {
        if (value.sociedad === yo.empresa && yo.tipo === value.tipo && yo.categoria === value.categoria && value.area_cultivo === yo.cultivo && value.fundo === yo.fundo && value.etapa === yo.etapa && value.campo === yo.campo && value.turno === yo.turno) {
          yo.codigo_h = value.cod_homologado
          yo.variedad = value.variedad
          yo.area = value.area_total
        }
      }
    },

    resetModal() {
      this.name = ''
      this.empresa = null
      this.tipo = null
      this.categoria = null
      this.cultivo = null
      this.fundo = null
      this.etapa = null
      this.campo = null
      this.turno = null
      this.limpiar()
      this.codigo_resp = null
      this.responsable_reg = null
      this.codigo_maq = null
      this.maquinaria = null
      this.codigo_act = null
      this.actividad = null
      this.labores = []
      this.codigo_lab = null
      this.labor = null
      this.ratio_obj = null
      this.avance_sem = null
      this.lunes = null
      this.martes = null
      this.miercoles = null
      this.jueves = null
      this.viernes = null
      this.sabado = null
      this.domingo = null
      this.comentario = null

      this.dataInicial()

      this.semana = this.semanaActual ? this.semana : this.semana_sig
    },

    buscarResponsable_reg() {
      const yo = this
      yo.responsable_reg = ""
      yo.loadingBP = true
      const data = JSON.stringify({ 'cod_resp': yo.codigo_resp, 'id_usuario': yo.id_user })
      const config = {
        method: 'post',
        url: '/pagricolas/obtener_responsable_req/',
        headers: {
          'Content-Type': 'application/json'
        },
        data: data
      }
      axiosIns(config)
        .then(function (response) {
          if (response.status === 200) {
            if (response.data['estado'] === true) {
              yo.responsable_reg = response.data['responsable']['nombre_responsable']
            } else {
              yo.mostrarNotificacion('¡Advertencia!', 'AlertTriangleIcon', "No se encontro Responsable con el código ingresado.", 'warning', 2000)
              yo.responsable_reg = null
            }
          }
        })
        .catch(function (error) {
          yo.mostrarNotificacion('¡Advertencia!', 'AlertTriangleIcon', "No se encontro Responsable con el código ingresado y/o No tiene relación con su Usuario.", 'warning', 2000)
          yo.responsable_reg = null
        })
        .finally(function () {
          yo.loadingBP = false
        })
    },

    buscarMaquinaria() {
      const yo = this
      yo.maquinaria = ""
      if (yo.empresa == null) {
        yo.mostrarNotificacion('¡Advertencia!', 'AlertTriangleIcon', "Debe Primero Seleccionar un Empresa.", 'warning', 2000)
      } else {
        yo.loadingBP = true
        const data = JSON.stringify({ 'cod_maq': yo.codigo_maq })
        const config = {
          method: 'post',
          url: '/pagricolas/obtener_maquinaria/',
          headers: {
            'Content-Type': 'application/json'
          },
          data: data
        }
        axiosIns(config)
          .then(function (response) {
            if (response.status === 200) {
              if (response.data['estado'] === true) {
                yo.maquinaria = response.data['maquina']['descripcion']
              } else {
                yo.mostrarNotificacion('¡Advertencia!', 'AlertTriangleIcon', "No se encontro Maquinaria con el código ingresado.", 'warning', 2000)
                yo.maquinaria = null
              }
            }
          })
          .catch(function (error) {
            yo.mostrarNotificacion('¡Advertencia!', 'AlertTriangleIcon', "No se encontro Maquinaria con el código ingresado.", 'warning', 2000)
            yo.maquinaria = null
          })
          .finally(function () {
            yo.loadingBP = false
          })
      }
    },

    buscarImplemento() {
      const yo = this
      yo.implemento = ""
      if (yo.empresa == null) {
        yo.mostrarNotificacion('¡Advertencia!', 'AlertTriangleIcon', "Debe Primero Seleccionar un Empresa.", 'warning', 2000)
      } else {
        yo.loadingBP = true
        const data = JSON.stringify({ 'cod_imp': yo.codigo_imp })
        const config = {
          method: 'post',
          url: '/pagricolas/obtener_implemento/',
          headers: {
            'Content-Type': 'application/json'
          },
          data: data
        }
        axiosIns(config)
          .then(function (response) {
            if (response.status === 200) {
              if (response.data['estado'] === true) {
                yo.implemento = response.data['implemento']['nombre']
              } else {
                yo.mostrarNotificacion('¡Advertencia!', 'AlertTriangleIcon', "No se encontro Implemento con el código ingresado.", 'warning', 2000)
                yo.implemento = null
              }
            }
          })
          .catch(function (error) {
            yo.mostrarNotificacion('¡Advertencia!', 'AlertTriangleIcon', "No se encontro Implemento con el código ingresado.", 'warning', 2000)
            yo.implemento = null
          })
          .finally(function () {
            yo.loadingBP = false
          })
      }
    },

    buscarActividad() {
      const yo = this
      yo.actividad = ""
      yo.labor = ""
      yo.codigo_lab = ""
      yo.labores = []
      if (yo.empresa == null) {
        yo.mostrarNotificacion('¡Advertencia!', 'AlertTriangleIcon', "Debe Primero Seleccionar un Empresa.", 'warning', 2000)
      } else {
        yo.loadingBP = true
        const data = JSON.stringify({ 'cod_act': yo.codigo_act, 'sociedad': yo.empresa })
        const config = {
          method: 'post',
          url: '/pagricolas/actividad_labor/',
          headers: {
            'Content-Type': 'application/json'
          },
          data: data
        }
        axiosIns(config)
          .then(function (response) {
            if (response.status === 200) {
              if (response.data['estado'] === true) {
                yo.actividad = response.data['Actividad'][0]['nombre']
                yo.labores = response.data['Labores']
              } else {
                yo.mostrarNotificacion('¡Advertencia!', 'AlertTriangleIcon', "No se encontro Actividad con el código ingresado.", 'warning', 2000)
                yo.actividad = null
              }
            }
          })
          .catch(function (error) {
            console.log(error);
            yo.mostrarNotificacion('¡Advertencia!', 'AlertTriangleIcon', "No se encontro Actividad con el código ingresado.", 'warning', 2000)
            yo.actividad = null
          })
          .finally(function () {
            yo.loadingBP = false
          })
      }

    },

    buscarLabor() {
      const yo = this
      yo.labor = ""
      console.log("Buscar Labor")
      if (yo.labores.length == 0) {
        yo.mostrarNotificacion('¡Advertencia!', 'AlertTriangleIcon', "Debe Primero Seleccionar Una Actividad", 'warning', 2000)
      } else {
        var existe = false;
        for (let i = 0; i < yo.labores.length; i++) {
          const element = yo.labores[i];

          if (element['cod_lab_alterno'] === yo.codigo_lab) {
            yo.labor = element['nombre']
            existe = true;
          }
        }
        if (existe != true) {
          yo.mostrarNotificacion('¡Advertencia!', 'AlertTriangleIcon', "No Existe esta Labor en la Actividad Seleccionada", 'warning', 2000)
        }
      }
    },


    traerMaquinaria() {
      const yo = this
      yo.loading = true

      const config = {
        method: 'get',
        url: '/pagricolas/maquinarias/'
      }

      axiosIns(config)
        .then(function (response) {
          if (response.status === 200) {
            yo.items = response.data;
            yo.spd = response.data;
            yo.totalRows = yo.items.length

            yo.empresasFiltro = []
            yo.semanasFiltro = []
            yo.cultivosFiltro = []
            yo.notDuplicados = []

            for (let valor of yo.items) {
              yo.empresasFiltro.push(valor.empresa)
              yo.semanasFiltro.push(valor.semana)
              yo.cultivosFiltro.push(valor.cultivo)
              yo.notDuplicados.push(valor.semana + valor.cultivo + valor.empresa + valor.fundo)

            }
            yo.empresasFiltro = [... new Set(yo.empresasFiltro)];
            yo.semanasFiltro = [... new Set(yo.semanasFiltro)];
            yo.cultivosFiltro = [... new Set(yo.cultivosFiltro)];
            yo.notDuplicados = [... new Set(yo.notDuplicados)];

            if (yo.responsable[0].rol === 'APROBADOR') {
              console.log("Aprobador")
              yo.estados = [
                { value: '2', text: "Aprobar" },
                { value: '3', text: "Observar" },
                { value: '4', text: "Desaprobar" }
              ]
              yo.items = yo.items.filter(
                invoice => invoice.empresa === yo.responsable[0].empresa && invoice.estado !== '0'
              )

            } else if (yo.responsable[0].rol === 'USUARIO') {
              yo.items = yo.items.filter(
                invoice => invoice.cultivo === yo.responsable[0].cultivo && invoice.empresa === yo.responsable[0].empresa
              )
              console.log(yo.responsable[0].cultivo, yo.responsable[0].empresa)
              yo.estados = [
                { value: '1', text: "Dar visto bueno" },
              ]
            } else {
              yo.estados = [
                { value: '1', text: "Dar visto bueno" },
                { value: '2', text: "Aprobar" },
                { value: '3', text: "Observar" },
                { value: '4', text: "Desaprobar" }
              ]
            }
          }
        })
        .catch(function (error) {
          console.log(error);
        })
        .finally(function () {
          yo.loading = false
        })
    },

    handleSubmit() {
      const yo = this
      this.$refs.formularioMaquinaria.validate().then(success => {
        if (success) {
          yo.loading2 = true
          const data = JSON.stringify({
            'semana': yo.semanaActual ? yo.semana : yo.semana_sig,
            'empresa': yo.empresa,
            'tipo': yo.tipo,
            'categoria': yo.categoria,
            'cultivo': yo.cultivo,
            'fundo': yo.fundo,
            'etapa': yo.etapa,
            'campo': yo.campo,
            'turno': yo.turno,
            'cod_homol': yo.codigo_h,
            'variedad': yo.variedad,
            'area': yo.area,
            'cod_responsable': yo.codigo_resp,
            'responsable': yo.responsable_reg,
            'cod_maquinaria': yo.codigo_maq,
            'maquinaria': yo.maquinaria,
            'cod_implemento': yo.codigo_imp,
            'implemento': yo.implemento,
            'cod_actividad': yo.codigo_act,
            'actividad': yo.actividad,
            'cod_labor': yo.codigo_lab,
            'labor': yo.labor,
            'hora_ini': yo.h_ini,
            'hora_fin': yo.h_fin,
            'ratio': yo.ratio_obj,
            'avance': yo.avance_sem,
            'lun': yo.lunes == true ? "SI" : "NO",
            'mar': yo.martes == true ? "SI" : "NO",
            'mie': yo.miercoles == true ? "SI" : "NO",
            'jue': yo.jueves == true ? "SI" : "NO",
            'vie': yo.viernes == true ? "SI" : "NO",
            'sab': yo.sabado == true ? "SI" : "NO",
            'dom': yo.domingo == true ? "SI" : "NO",
            'comentarios': yo.comentario,
            'estado': '0',
            'con_usuario_id': yo.id_user,
          })

          const config = {
            method: 'post',
            url: 'pagricolas/maquinaria/crear/',
            headers: {
              'Content-Type': 'application/json'
            },
            data: data
          }
          axiosIns(config)
            .then(function (response) {
              if (response.status === 200) {
                yo.mostrarNotificacion('¡Bien hecho!', 'CheckIcon', "El registro se realizó de manera correcta", 'success', 5000)
              }
            })
            .catch(function (error) {
              console.log(error);
              yo.mostrarNotificacion('Error en el registro', 'BellIcon', error.toString(), 'danger', 5000)
            })
            .finally(function () {
              yo.traerMaquinaria()
              yo.$nextTick(() => {
                yo.$refs['my-modal'].toggle('#toggle-btn')
              })
              yo.loading2 = false
            })
        }
      })
    },

    handleOk(bvModalEvt) {
      bvModalEvt.preventDefault()
      this.handleSubmit()
    },
    importarOk(bvModalEvtImp) {
      bvModalEvtImp.preventDefault()
      this.enviarFile()
    },

    comporbarExcedente() {

      const suma = parseFloat(this.lunes) + parseFloat(this.martes) + parseFloat(this.miercoles) + parseFloat(this.jueves) + parseFloat(this.viernes) + parseFloat(this.sabado) + parseFloat(this.domingo)
      const resultado = (suma / parseInt(this.dias)).toLocaleString('es-PE', { maximumFractionDigits: 5 })

      console.log("resultado: " + resultado + "  - total_max: " + this.total_max_dia)

      if (resultado === this.total_max_dia) {
        this.indicador = '0.0'
      } else {
        this.indicador = resultado
      }

    },

    asignarInicioFinSemana() {
      this.inicioSemana = ''
      this.finSemana = ''

      if (this.semana >= 1 && this.semana <= 52) {
        const hoy = new Date()
        const fech = new Date(Date.UTC(hoy.getFullYear(), 0, 1));

        fech.setDate(fech.getDate() + (this.semana * 7));

        const inicio = new Date(fech.getFullYear(), fech.getMonth(), fech.getDate() - fech.getDay() + 1)
        const fin = new Date(fech.getFullYear(), fech.getMonth(), fech.getDate() + 7 - fech.getDay())

        this.inicioSemana = inicio.toLocaleString('pe-PE', {
          month: 'long',
          day: '2-digit',
          year: 'numeric',
          localeMatcher: 'best fit',
          timeZone: 'America/Lima'
        })
        this.finSemana = fin.toLocaleString('pe-PE', {
          month: 'long',
          day: '2-digit',
          year: 'numeric',
          localeMatcher: 'best fit',
          timeZone: 'America/Lima'
        })
      }
    },

    enviarFile() {
      const yo = this
      this.$refs.formularioImportar.validate().then(success => {
        if (success) {
          yo.loadingIMP = true
          const data = new FormData();
          data.append('file', yo.archivo_excel)
          data.append('con_usuario', yo.id_user)
          data.append('semana', yo.semanaEnviar)
          const config = {
            method: 'post',
            url: '/pagricolas/cargar_excel_pag_maq/',
            headers: {
              'Content-Type': 'multipart/form-data'
            },
            data: data
          }

          axiosIns(config)
            .then(function (response) {
              if (response.status === 200) {
                yo.traerMaquinaria()
                yo.respuestaRegistrosTotal = response.data['total']
                yo.respuestaErrores = response.data['errores']
              }
            })
            .catch(function (error) {
              console.log(error);
              yo.$toast({
                component: ToastificationContent,
                props: {
                  title: 'Error en el registro',
                  icon: 'XIcon',
                  text: 'Hubo un error en el registro, intentelo nuevamente en unos minutos.',
                  variant: 'danger',
                },
              })
            })
            .finally(function () {
              yo.archivo_excel = null

              yo.loadingIMP = false
              yo.$nextTick(() => {
                yo.$refs['modal-importar'].toggle('#toggle-btn')
              })
              yo.estadoModalRespuesta = true
            })

        }
      })
    },

    autorizar(data) {
      this.estado_aprobar = null

      if (data['estado'] === '0') {
        this.modalEditarEstadoShow = true
        // this.dataAutorizar = data.semana + "*" + data.tipo + "*" + data.cultivo + "*" + data.empresa + "*" + data.fundo
        this.dataAutorizar = data.id
      } else {
        if (this.responsable[0].rol === 'USUARIO') {
          this.mostrarNotificacion('Advertencia', 'BellIcon', "Solo se pueden seleccionar los registro con aprobación pendiente.", 'warning', 6000)
        } else {
          this.modalEditarEstadoShow = true
          // this.dataAutorizar = data.semana + "*" + data.tipo + "*" + data.cultivo + "*" + data.empresa + "*" + data.fundo
          this.dataAutorizar = data.id
        }
      }
    },
    exportarDataExcel() {
      const yo = this
      yo.loadingExp = true
      const data = JSON.stringify({ 'id_user': yo.id_user, 'semana': yo.semana })
      const config = {
        method: 'post',
        url: '/pagricolas/Plantilla/exportar/',
        headers: {
          'Content-Type': 'application/json'
        },
        data: data,
        responseType: 'arraybuffer',
      }
      axiosIns(config)
        .then(function (response) {
          if (response.status === 200) {
            const fileURL = window.URL.createObjectURL(new Blob([response.data]));
            const fileLink = document.createElement('a');
            fileLink.href = fileURL;
            fileLink.setAttribute('download', "Plantilla Maquinaria.xlsx");
            document.body.appendChild(fileLink);
            fileLink.click();

            yo.$toast({
              component: ToastificationContent,
              props: {
                title: 'Archivo Generado',
                icon: 'CheckIcon',
                text: 'El archivo se creó satisfactoriamente.',
                variant: 'success',
              },
            },
              {
                position: 'top-center',
              })
          }
        })
        .catch(function (error) {
          console.log(error);
          yo.$toast({
            component: ToastificationContent,
            props: {
              title: 'Error en la creación del archivo',
              icon: 'XIcon',
              text: 'Hubo un error en la creación del archivo, intentelo nuevamente en unos minutos.',
              variant: 'danger',
            },
          })
        })
        .finally(function () {
          yo.loadingExp = false
        });
    },
    verDetalle(datos) {
      const yo = this
      yo.items_sem_act = yo.spd.filter(invoice => invoice.semana + invoice.cultivo + invoice.empresa + invoice.fundo === datos.semana + datos.cultivo + datos.empresa + datos.fundo)

      yo.mostrarSemAct = true
    },

    verDetalleSemSgte(datos) {
      const yo = this
      yo.items_sem_sgte = yo.spd.filter(invoice => invoice.semana + invoice.cultivo + invoice.empresa + invoice.fundo === datos.semana + datos.cultivo + datos.empresa + datos.fundo)

      yo.mostrarSemSgte = true
    },

    validarEditar(datos, a_s) {
      const yo = this

      if (datos['estado'] === '0' || datos['estado'] === '3') {
        const config = {
          method: 'get',
          url: '/pagricolas/parametrosCompleto_maq/?cod=' + yo.id_user
        }

        axiosIns(config)
          .then(function (response) {
            if (response.status === 200) {
              const parametros_total = response.data['parametros'].filter(
                invoice => invoice.id === 12
              );
              const parametros_actual = response.data['parametros'].filter(
                invoice => invoice.id === 13
              );
              const parametros_sgte = response.data['parametros'].filter(
                invoice => invoice.id === 14
              );

              if (parametros_total[0]['estado'] === '0') {
                yo.parametros = parametros_total
              }
              else if (a_s) {
                if (parametros_actual[0]['estado'] === '0') {
                  yo.parametros = parametros_actual
                } else {
                  yo.parametros = [{
                    'valor': response.data['usuario'][0]['valor'],
                    'valor2': response.data['usuario'][0]['valor_1']
                  }]
                }
              }
              else {
                if (parametros_sgte[0]['estado'] === '0') {
                  yo.parametros = parametros_sgte
                } else {
                  yo.parametros = [{
                    'valor': response.data['usuario'][0]['valor_2'],
                    'valor2': response.data['usuario'][0]['valor_3']
                  }]
                }
              }

              yo.dia = yo.parametros[0]['valor']
              yo.hora = yo.parametros[0]['valor2']
              console.log(yo.parametros[0])
              let valorDia = 0

              const horaInicial = yo.hora.split(':')

              if (yo.dia === 'LUNES') {
                valorDia = 1
              } else if (yo.dia === 'MARTES') {
                valorDia = 2
              } else if (yo.dia === 'MIÉRCOLES') {
                valorDia = 3
              } else if (yo.dia === 'JUEVES') {
                valorDia = 4
              } else if (yo.dia === 'VIERNES') {
                valorDia = 5
              } else if (yo.dia === 'SÁBADO') {
                valorDia = 6
              } else if (yo.dia === 'DOMINGO') {
                valorDia = 7
              }

              const ahora = new Date()

              const fechaInicial = new Date(ahora.getUTCFullYear(), ahora.getUTCMonth(), ahora.getUTCDate(), parseInt(horaInicial[0]), parseInt(horaInicial[1]), parseInt(horaInicial[2]))

              if (ahora.getDay() < valorDia) {
                yo.mostrarModalEditar(datos)
              } else if (ahora.getDay() === valorDia) {
                if (ahora <= fechaInicial) {
                  yo.mostrarModalEditar(datos)
                } else {
                  yo.mostrarNotificacion('¡Advertencia!', 'BellIcon', "No pueden agregar nuevos registros porque se encuentra fuera del límite programado.", 'warning', 5000)
                }
              } else {
                yo.mostrarNotificacion('¡Advertencia!', 'BellIcon', "No pueden agregar nuevos registros porque se encuentra fuera del límite programado.", 'warning', 5000)
              }
            }
          })
          .catch(function (error) {
            console.log(error);
          })
          .finally(function () {
            yo.loading = false
          })
      }
      else {
        this.mostrarNotificacion('Advertencia', 'BellIcon', "Solo se pueden editar los registro pendientes u observados.", 'warning', 6000)
      }
    },

    mostrarModalEditar(datos) {
      const yo = this
      yo.estadoModalEditar = true
      yo.semana = datos['semana']
      yo.empresa = datos['empresa']
      yo.asignarTipos()
      yo.tipo = datos['tipo']
      yo.asignarCategoria()
      yo.categoria = datos['categoria']
      yo.asignarCultivos()
      yo.cultivo = datos['cultivo']
      yo.asignarFundos()
      yo.fundo = datos['fundo']
      yo.asignarEtapas()
      yo.etapa = datos['etapa']
      yo.asignarCampos()
      yo.campo = datos['campo']
      yo.asignarTurnos()
      yo.turno = datos['turno']
      yo.codigo_h = datos['cod_homol']
      yo.variedad = datos['variedad']
      yo.area = datos['area']
      yo.codigo_resp = datos['cod_responsable']
      yo.responsable_reg = datos['responsable']
      yo.codigo_maq = datos['cod_maquinaria']
      yo.maquinaria = datos['maquinaria']
      yo.codigo_imp = datos['cod_implemento']
      yo.implemento = datos['implemento']
      yo.codigo_act = datos['cod_actividad']
      yo.actividad = datos['actividad']
      yo.codigo_lab = datos['cod_labor']
      yo.labor = datos['labor']
      yo.h_ini = datos['hora_ini']
      yo.h_fin = datos['hora_fin']
      yo.ratio_obj = datos['ratio']
      yo.avance_sem = datos['avance']
      yo.comentario = datos['comentarios']
      yo.lunes = datos['lun'] == "SI" ? true : false
      yo.martes = datos['mar'] == "SI" ? true : false
      yo.miercoles = datos['mie'] == "SI" ? true : false
      yo.jueves = datos['jue'] == "SI" ? true : false
      yo.viernes = datos['vie'] == "SI" ? true : false
      yo.sabado = datos['sab'] == "SI" ? true : false
      yo.domingo = datos['dom'] == "SI" ? true : false
    },

    aprobar() {
      const yo = this

      const config = {
        method: 'get',
        url: '/pagricolas/editar_estado_maq/?datos=' + yo.dataAutorizar + "*" + yo.estado_aprobar
      }

      axiosIns(config)
        .then(function (response) {
          if (response.status === 200) {
            yo.mostrarNotificacion('¡Bien hecho!', 'CheckIcon', "El registro se actualizó de manera correcta", 'success', 5000)
          }

        })
        .catch(function (error) {
          console.log(error);
          yo.mostrarNotificacion('¡Advertencia!', 'AlertTriangleIcon', "No se encontraron productos con el código ingresado.", 'warning', 2000)
        })
        .finally(function () {
          yo.traerMaquinaria()
        })
    },

    EditarRegistro() {
      const yo = this
      yo.mostrarNotificacion('En Mantenimiento!', 'AlertTriangleIcon', "No se Guardaron los Cambios.", 'warning', 2000)
    },

    modal_registro(valor) {
      const yo = this
      const config = {
        method: 'get',
        url: '/pagricolas/parametrosCompleto_maq/?cod=' + yo.id_user
      }

      axiosIns(config)
        .then(function (response) {
          if (response.status === 200) {
            const parametros_total = response.data['parametros'].filter(invoice => invoice.id === 12);
            const parametros_actual = response.data['parametros'].filter(invoice => invoice.id === 13);
            const parametros_sgte = response.data['parametros'].filter(invoice => invoice.id === 14);

            if (parametros_total[0]['estado'] === '0') {
              yo.parametros = parametros_total
            }
            else if (valor) {
              if (parametros_actual[0]['estado'] === '0') {
                yo.parametros = parametros_actual
              } else {
                yo.parametros = [{
                  'valor': response.data['usuario'][0]['valor'],
                  'valor2': response.data['usuario'][0]['valor_1']
                }]
              }
            }
            else {
              if (parametros_sgte[0]['estado'] === '0') {
                yo.parametros = parametros_sgte
              } else {
                yo.parametros = [{
                  'valor': response.data['usuario'][0]['valor_2'],
                  'valor2': response.data['usuario'][0]['valor_3']
                }]
              }
            }

            if (valor) {
              yo.title_sem = `Ingresar nueva programación - Semana ${yo.semana} - Del ${yo.inicioSemana} al ${yo.finSemana}`
              yo.semanaActual = true
            } else {
              yo.title_sem = `Ingresar nueva programación - Semana ${yo.semana_sig} - Del ${yo.inicioSemana_sig} al ${yo.finSemana_sig}`
              yo.semanaActual = false
            }
            yo.dia = yo.parametros[0]['valor']
            yo.hora = yo.parametros[0]['valor2']

            let valorDia = 0

            const horaInicial = yo.hora.split(':')

            if (yo.dia === 'LUNES') {
              valorDia = 1
            } else if (yo.dia === 'MARTES') {
              valorDia = 2
            } else if (yo.dia === 'MIÉRCOLES') {
              valorDia = 3
            } else if (yo.dia === 'JUEVES') {
              valorDia = 4
            } else if (yo.dia === 'VIERNES') {
              valorDia = 5
            } else if (yo.dia === 'SÁBADO') {
              valorDia = 6
            } else if (yo.dia === 'DOMINGO') {
              valorDia = 7
            }

            const ahora = new Date()

            const fechaInicial = new Date(ahora.getUTCFullYear(), ahora.getUTCMonth(), ahora.getUTCDate(), parseInt(horaInicial[0]), parseInt(horaInicial[1]), parseInt(horaInicial[2]))
            if (ahora.getDay() < valorDia) {
              yo.modal_registro_o = true
            }
            else if (ahora.getDay() === valorDia) {
              if (ahora <= fechaInicial) {
                yo.modal_registro_o = true
              } else {
                yo.mostrarNotificacion('¡Advertencia!', 'BellIcon', "No pueden agregar nuevos registros porque se encuentra fuera del límite programado.", 'warning', 5000)
              }
            } else {
              yo.mostrarNotificacion('¡Advertencia!', 'BellIcon', "No pueden agregar nuevos registros porque se encuentra fuera del límite programado.", 'warning', 5000)
            }
          }
        })
        .catch(function (error) {
          console.log(error);
        })
        .finally(function () {
          yo.loading = false
        })
    },

    mostrarModalImportar(valor) {
      const yo = this
      const config = {
        method: 'get',
        url: '/pagricolas/parametrosCompleto_maq/?cod=' + yo.id_user
      }

      yo.loadingSAM = valor
      yo.loadingSSM = !valor

      axiosIns(config)
        .then(function (response) {
          if (response.status === 200) {
            const parametros_total = response.data['parametros'].filter(
              invoice => invoice.id === 12
            );
            const parametros_actual = response.data['parametros'].filter(
              invoice => invoice.id === 13
            );
            const parametros_sgte = response.data['parametros'].filter(
              invoice => invoice.id === 14
            );

            if (parametros_total[0]['estado'] === '0') {
              yo.parametros = parametros_total
            }
            else if (valor) {
              if (parametros_actual[0]['estado'] === '0') {
                yo.parametros = parametros_actual
              } else {
                yo.parametros = [{
                  'valor': response.data['usuario'][0]['valor'],
                  'valor2': response.data['usuario'][0]['valor_1']
                }]
              }
            }
            else {
              if (parametros_sgte[0]['estado'] === '0') {
                yo.parametros = parametros_sgte
              } else {
                yo.parametros = [{
                  'valor': response.data['usuario'][0]['valor_2'],
                  'valor2': response.data['usuario'][0]['valor_3']
                }]
              }
            }

            yo.semanaEnviar = valor ? yo.semana : yo.semana_sig

            yo.dia = yo.parametros[0]['valor']
            yo.hora = yo.parametros[0]['valor2']
            console.log(yo.parametros[0])
            let valorDia = 0

            const horaInicial = yo.hora.split(':')

            if (yo.dia === 'LUNES') {
              valorDia = 1
            } else if (yo.dia === 'MARTES') {
              valorDia = 2
            } else if (yo.dia === 'MIÉRCOLES') {
              valorDia = 3
            } else if (yo.dia === 'JUEVES') {
              valorDia = 4
            } else if (yo.dia === 'VIERNES') {
              valorDia = 5
            } else if (yo.dia === 'SÁBADO') {
              valorDia = 6
            } else if (yo.dia === 'DOMINGO') {
              valorDia = 7
            }

            const ahora = new Date()

            const fechaInicial = new Date(ahora.getUTCFullYear(), ahora.getUTCMonth(), ahora.getUTCDate(), parseInt(horaInicial[0]), parseInt(horaInicial[1]), parseInt(horaInicial[2]))

            if (ahora.getDay() < valorDia) {
              yo.estadoModalImportar = true
            }
            else if (ahora.getDay() === valorDia) {
              if (ahora <= fechaInicial) {
                yo.estadoModalImportar = true
              } else {
                yo.mostrarNotificacion('¡Advertencia!', 'BellIcon', "No pueden agregar nuevos registros porque se encuentra fuera del límite programado.", 'warning', 5000)
              }
            } else {
              yo.mostrarNotificacion('¡Advertencia!', 'BellIcon', "No pueden agregar nuevos registros porque se encuentra fuera del límite programado.", 'warning', 5000)
            }
          }
        })
        .catch(function (error) {
          console.log(error);
        })
        .finally(function () {
          yo.loadingSAM = false
          yo.loadingSSM = false
        })

    },

  },
}
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';

.custom-file-input:lang(en)~.custom-file-label::after {
  content: '';
}

.tablaferti {
  min-height: 52vh !important;
}

.tablaferti::-webkit-scrollbar {
  width: 1.35vh;
  height: 1.35vh;
}

.tablaferti::-webkit-scrollbar-track {
  background-color: rgba(171, 171, 171, 0.35);
  border-radius: 6px;
  position: absolute;
}

.tablaferti::-webkit-scrollbar-thumb {
  background-image: linear-gradient(47deg, #82868b, #9ca0a4);
  border-radius: 6px;
  position: absolute;
}
</style>
